import { useTranslation } from 'react-i18next';
import { Section, SectionHeader } from 'components/ds';
import { StorePhotoSlots } from './StorePhotoSlots';
import type { StorePhoto, StoreSlot } from './StorePhotoSlots';
import { VisitPhotoSection } from './VisitPhotos';
import type { VisitPhoto } from './VisitPhotos';

/**
 * 장소 사진을 두 갈래로 나눠 보여줍니다.
 *
 * 가게 사진과 방문 사진을 라벨로 구분하면 아무도 안 읽습니다.
 * 자리를 나누면 어디에 있느냐가 곧 구분이 됩니다 —
 * 위는 네 자리로 정해진 가게 사진, 아래는 다녀온 사람들이 올린 방문 사진.
 */
export const PlacePhotoSections = ({
    storePhotos, visitPosts, visitTotal, canAdd,
    onPickStore, onOpenStore, onAddVisit, onMoreVisit, onOpenVisit,
}: {
    storePhotos: StorePhoto[];
    visitPosts: VisitPhoto[];
    visitTotal?: number;
    /** 지금 사진을 올릴 수 있는 상태인가 (진행 중 + 도착) */
    canAdd?: boolean;
    onPickStore?: (slot: StoreSlot, files: File[]) => void;
    onOpenStore?: (photo: StorePhoto) => void;
    onAddVisit?: () => void;
    onMoreVisit?: () => void;
    onOpenVisit?: (post: VisitPhoto, index: number) => void;
}) => {
    const { t } = useTranslation();

    return (
        <>
            <Section divided>
                <SectionHeader title={t('storePhoto.sectionTitle')} />
                <StorePhotoSlots
                    photos={storePhotos}
                    canAdd={canAdd}
                    onPick={onPickStore}
                    onOpen={onOpenStore}
                />
            </Section>

            <Section divided>
                <VisitPhotoSection
                    posts={visitPosts}
                    total={visitTotal}
                    canAdd
                    onAdd={onAddVisit}
                    onMore={onMoreVisit}
                    onOpen={onOpenVisit}
                />
            </Section>
        </>
    );
};
